import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { FileText } from 'lucide-react';
import { openArtifact, useEntityArtifacts } from '../../Capture/documentHooks';
/** The entity type a file filed on a registry company is linked under. */ export const COMPANY_PROFILE_ENTITY = 'company_profile';
/**
 * Files filed on this registry company: paperwork no program owns (an NDA,
 * a capability statement, teaming for a pursuit). A company's paperwork on a
 * program lives on that program's Companies tab instead.
 */ export function CompanyDocumentsSection({ profileId }) {
    const { data: files = [], isLoading, isError } = useEntityArtifacts(COMPANY_PROFILE_ENTITY, profileId);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": Testids.deliveryRegistries.companyDocumentsSection,
        className: "space-y-2",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "text-[length:var(--fs-ui-caption)] font-medium uppercase tracking-wider text-muted-foreground",
                children: "Documents"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text-xs text-muted-foreground",
                children: "Files about this company that no program owns. Paperwork for a program is on that program's Companies tab."
            }),
            isLoading && /*#__PURE__*/ _jsx("p", {
                className: "text-xs text-muted-foreground",
                children: "Loading…"
            }),
            isError && /*#__PURE__*/ _jsx("p", {
                className: "text-xs text-destructive",
                children: "Documents could not be loaded."
            }),
            !isLoading && !isError && files.length === 0 && /*#__PURE__*/ _jsx("p", {
                className: "text-xs text-muted-foreground",
                children: "No documents yet. Drop files in the assistant and ask it to file them."
            }),
            files.map((f)=>/*#__PURE__*/ _jsxs(SpecraButton, {
                    variant: "ghost",
                    fullWidth: true,
                    "data-testid": Testids.deliveryRegistries.companyDocumentRow,
                    className: "h-auto justify-start gap-2 rounded-md border border-border/60 p-2 text-left text-[length:var(--fs-ui-caption)]",
                    onClick: ()=>void openArtifact(f.artifactId),
                    children: [
                        /*#__PURE__*/ _jsx(FileText, {
                            className: "h-3.5 w-3.5 shrink-0 text-muted-foreground",
                            "aria-hidden": true
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "truncate font-medium",
                            children: f.filename || 'Untitled file'
                        })
                    ]
                }, f.artifactId))
        ]
    });
}
